import {Button,Empty} from 'antd';
import {CenteredContent} from 'components/container';
import Error,{PageError} from './error';

export const Fallback = ({ error, componentStack, resetErrorBoundary }) => {
  return (
    <CenteredContent>
      <Error error={error}/>
      <Button type="primary" onClick={resetErrorBoundary}>Try again</Button>
    </CenteredContent>
  );
};
export const FallbackEmpty = ({ error, componentStack, resetErrorBoundary }) => {
  return (
    <CenteredContent>
      <Empty />      
    </CenteredContent>
  );
};

export const FallbackPage = ({ error, componentStack, resetErrorBoundary }) => {
  return (
    <CenteredContent>
      <PageError {...error} onClick={resetErrorBoundary}/>      
    </CenteredContent>
  );
};